import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useI18n } from '@ah/i18n';
import { GlobalCrisisBar } from '../../features/home/GlobalCrisisBar';
import { routes } from './routes';

const HomePage = lazy(() => import('../../features/home/HomePage'));
const SettingsPage = lazy(() => import('../../features/settings/SettingsPage'));
const LoginPage = lazy(() => import('../../features/auth/LoginPage'));
const RegisterClientPage = lazy(() => import('../../features/auth/RegisterClientPage'));
const VerifyEmailPage = lazy(() => import('../../features/auth/VerifyEmailPage'));
const CallPage = lazy(() => import('../../features/voice/CallPage'));
const CheckInPage = lazy(() => import('../../features/ai/CheckInPage'));
const FindTherapistPage = lazy(() => import('../../features/matching/FindTherapistPage'));
const TherapistProfilePage = lazy(() => import('../../features/matching/TherapistProfilePage'));
const BookingPage = lazy(() => import('../../features/booking/BookingPage'));
const PaymentSuccessPage = lazy(() => import('../../features/payments/PaymentSuccessPage'));
const PaymentCancelledPage = lazy(() => import('../../features/payments/PaymentCancelledPage'));
const LegalPage = lazy(() => import('../../features/content/LegalPage'));
const AgreementTermsPage = lazy(() => import('../../features/content/AgreementTermsPage'));

function Loading() {
  const { t } = useI18n();
  return (
    <div role="status" style={{ padding: 24, textAlign: 'center' }}>
      {t('common.loading')}
    </div>
  );
}

export function AppRouter() {
  return (
    <BrowserRouter>
      {/* Above <Suspense> on purpose: the crisis line must be on screen even
          while a lazy route chunk is still downloading. */}
      <GlobalCrisisBar />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path={routes.home}     element={<HomePage />} />
          <Route path={routes.login}    element={<LoginPage />} />
          <Route path={routes.register} element={<RegisterClientPage />} />
          <Route path={routes.verifyEmail} element={<VerifyEmailPage />} />
          <Route path={routes.settings} element={<SettingsPage />} />
          <Route path={routes.call}     element={<CallPage />} />
          <Route path={routes.checkIn}  element={<CheckInPage />} />
          <Route path={routes.findTherapist} element={<FindTherapistPage />} />
          <Route path={routes.therapistProfile} element={<TherapistProfilePage />} />
          <Route path={routes.book}          element={<BookingPage />} />
          <Route path={routes.paymentSuccess}   element={<PaymentSuccessPage />} />
          <Route path={routes.paymentCancelled} element={<PaymentCancelledPage />} />
          <Route path={routes.agreementTerms} element={<AgreementTermsPage />} />
          <Route path={routes.terms}   element={<LegalPage />} />
          <Route path={routes.privacy} element={<LegalPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
